import { API_BASE_URL } from '../config';

export interface PaymentLinkResponse {
  paymentUrl: string;
  preferenceId: string;
  expiresAt: string;
}

export async function generatePaymentLink(
  quoteId: string,
  accessToken: string,
  force = false
): Promise<PaymentLinkResponse> {
  const url = `${API_BASE_URL}/backoffice/quotes/${quoteId}/payment-link${force ? '?force=true' : ''}`;
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  if (!response.ok) {
    const payload = await response.json().catch(() => undefined);
    throw new Error(payload?.error?.message || 'Erro ao gerar link de pagamento');
  }

  const result = await response.json();
  return result.data;
}

export async function generateMedalPaymentLink(
  quoteId: string,
  accessToken: string,
  force = false
): Promise<PaymentLinkResponse> {
  const url = `${API_BASE_URL}/backoffice/medals/quotes/${quoteId}/payment-link${force ? '?force=true' : ''}`;
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  if (!response.ok) {
    const payload = await response.json().catch(() => undefined);
    throw new Error(payload?.error?.message || 'Erro ao gerar link de pagamento');
  }

  const result = await response.json();
  return result.data;
}

export async function generateTrophyPaymentLink(
  quoteId: string,
  accessToken: string,
  force = false
): Promise<PaymentLinkResponse> {
  const url = `${API_BASE_URL}/backoffice/trophies/quotes/${quoteId}/payment-link${force ? '?force=true' : ''}`;
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  if (!response.ok) {
    const payload = await response.json().catch(() => undefined);
    throw new Error(payload?.error?.message || 'Erro ao gerar link de pagamento');
  }

  const result = await response.json();
  return result.data;
}

export async function generatePlacaPaymentLink(
  quoteId: string,
  accessToken: string,
  force = false
): Promise<PaymentLinkResponse> {
  const url = `${API_BASE_URL}/backoffice/placas/quotes/${quoteId}/payment-link${force ? '?force=true' : ''}`;
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  if (!response.ok) {
    const payload = await response.json().catch(() => undefined);
    throw new Error(payload?.error?.message || 'Erro ao gerar link de pagamento');
  }

  const result = await response.json();
  return result.data;
}

export async function generateTombstonePaymentLink(
  quoteId: string,
  accessToken: string,
  force = false
): Promise<PaymentLinkResponse> {
  const url = `${API_BASE_URL}/backoffice/tombstones/quotes/${quoteId}/payment-link${force ? '?force=true' : ''}`;
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  if (!response.ok) {
    const payload = await response.json().catch(() => undefined);
    throw new Error(payload?.error?.message || 'Erro ao gerar link de pagamento');
  }

  const result = await response.json();
  return result.data;
}
